// extracted by mini-css-extract-plugin
module.exports = {"doctor":"style_doctor__1w5h5"};